:host {
  padding: 0 calc(var(--spacer) * 2) 0 calc(var(--spacer) * 2);
  --body-size-xxlarge: 24px; // override button size
}

.gz-phasr-side-panel-wrapper {
  padding-top: calc(var(--spacer) * 4);
  padding-bottom: calc(var(--spacer) * 2);
  display: flex;
  height: inherit;
  flex-direction: column;
  position: relative;

  .back-button{
    position: absolute;
    top: calc(var(--spacer) * 2);
    left: 0;
  }

  .side-panel-title {
    margin-top: calc(var(--spacer) * 4);
    margin-bottom: calc(var(--spacer) * 4);
  }

  .side-panel-label-switch {
    min-width: 80%;
    width: fit-content;
    margin-bottom: calc(var(--spacer) * 2);
  }

  .search-container {
    margin-bottom: calc(var(--spacer) * 2);
  }
  .phasr-list-container {
    position: relative;
    height: 100%;

    gz-phasr-list {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
    }
  }

  .action-buttons-container {
    margin: calc(var(--spacer) * 2) 0;
  }
}
